export default {
  required: '必填项',
  numAndLetter: '必须为数字与字母组合',
  numeric: '必须为数字',
  email: '邮箱格式不正确',
  phone: '手机号格式不正确',
  specialCharacter: '格式错误，不能包含特殊符号',
  userNickname: '昵称需在1～20字且不含特殊字符',
  userFullName: '2~15个汉字或4～30字英语',
  userQQ: '5～20字的数字',
  userDesc: '签名字数不得大于200字',
  minLength({ min }) {
    return `最少${min}位字符`
  },
  maxLength({ max }) {
    return `最多${max}位字符`
  },
  equalTo({ length }) {
    return `应为${length}位字符`
  }
}
